<div class="icono_candado"><img src="assets/images/vectors84361614.svg" width="12px" height="15.75px" class="vector">
</div>